<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="pageData.currentPage"
    :page-size="pageData.pageSize"
    layout="total, prev, pager, next, jumper"
    :total="pageData.total"></el-pagination>
</template>

<script>
export default {
  name: 'paging',
  props: {
    pageData: Object,
  },
  data() {
    return {}
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //改变页码时触发的函数，val为当前页
    handleCurrentChange(val) {
      this.$emit('pageChange', val)
    },
  },
};
</script>

<style scoped>
.el-pagination {
  text-align: center;
  margin-top: 16px;
}
</style>